<svg:g [style.transform]="transform" *ngIf="title.draw">
    <svg:text class="title" [style.textAnchor]="textAnchor">
        {{ title.text }}
    </svg:text>
</svg:g>
